import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./FAQ.css";

function FAQ() {
  const es_en = useSelector((state) => state.translation);
  const [expandedId, setExpandedId] = useState(null);

  const faqs = [
    {
      id: 1,
      question: es_en
        ? "Are you open to remote, hybrid, or onsite roles?"
        : "¿Estás abierto a roles remotos, híbridos o presenciales?",
      answer: es_en
        ? "I am open to any work model, although I am currently looking primarily for fully remote opportunities. I can also consider hybrid or onsite roles in Madrid or Valencia depending on the project and team fit."
        : "Estoy abierto a trabajar en cualquier modalidad, aunque actualmente estoy buscando principalmente oportunidades 100% remotas. También puedo valorar posiciones híbridas o presenciales en Madrid o Valencia, según el proyecto y el encaje del equipo.",
    },
    {
      id: 2,
      question: es_en
        ? "What technologies do you work with most often?"
        : "¿Con qué tecnologías trabajas más habitualmente?",
      answer: es_en
        ? "I usually work with Node.js, Angular, PostgreSQL, NestJS, Docker, and TypeScript. In my day-to-day workflow I also use Visual Studio Code, AI assistants like Claude to speed up analysis and development, and different tools focused on code quality, testing, and delivery best practices."
        : "Trabajo habitualmente con Node.js, Angular, PostgreSQL, NestJS, Docker y TypeScript. En mi día a día también utilizo Visual Studio Code, asistentes de IA como Claude para acelerar análisis y desarrollo, y distintas herramientas orientadas a calidad de código, testing y buenas prácticas de entrega.",
    },
    {
      id: 3,
      question: es_en
        ? "What kind of roles fit your profile best?"
        : "¿Qué tipo de roles encajan mejor con tu perfil?",
      answer: es_en
        ? "The roles that fit me best are Full Stack positions with strong frontend weight, as well as opportunities where I can contribute with technical leadership. I like understanding the full data flow and business logic so I can adapt better to the solution and contribute beyond implementation. Even though I work well as a Full Stack developer, my strongest experience so far has been in frontend."
        : "Los roles que mejor encajan conmigo son los de Full Stack con peso en frontend, así como posiciones donde pueda aportar liderazgo técnico. Me gusta entender bien el flujo completo de los datos y la lógica del negocio para adaptarme mejor a la solución y aportar valor más allá de la implementación. Aunque me desenvuelvo bien como Full Stack, mi experiencia más sólida hasta ahora ha estado centrada en frontend.",
    },
    {
      id: 4,
      question: es_en
        ? "Do you have experience working in teams and agile environments?"
        : "¿Tienes experiencia trabajando en equipo y en entornos ágiles?",
      answer: es_en
        ? "Yes. I have experience working with teams using agile methodologies, especially Scrum. I have also worked regularly with pull requests and CI/CD processes as part of collaborative development and delivery workflows."
        : "Sí. Tengo experiencia trabajando en equipo con metodologías ágiles, especialmente Scrum. También he trabajado de forma habitual con pull requests y procesos de CI/CD como parte del flujo colaborativo de desarrollo y entrega.",
    },
    {
      id: 5,
      question: es_en
        ? "What is your level of English and communication style?"
        : "¿Cuál es tu nivel de inglés y cómo es tu comunicación?",
      answer: es_en
        ? "My English is fluent and I have worked with English-speaking teams without any problem, both in day-to-day communication and in technical contexts."
        : "Mi nivel de inglés es fluido y he trabajado sin problema con equipos en inglés, tanto en la comunicación diaria como en contextos técnicos.",
    },
    {
      id: 6,
      question: es_en
        ? "What can you bring to a new team in the first months?"
        : "¿Qué puedes aportar a un nuevo equipo en los primeros meses?",
      answer: es_en
        ? "I bring fast adaptation, strong communication, and creativity to solve problems. I usually contribute a lot to process improvement, workflow optimisation, and automation opportunities, and I like understanding business logic well enough to propose solutions that are actually useful."
        : "Aporto adaptación rápida, buena comunicación y creatividad para resolver problemas. Suelo contribuir mucho a la mejora de flujos, optimización de procesos y automatizaciones, y me gusta entender bien la lógica del negocio para proponer soluciones que realmente aporten valor.",
    },
  ];

  const toggleExpanded = (id) => {
    setExpandedId((currentId) => (currentId === id ? null : id));
  };

  return (
    <section className="faq section" id="faq">
      <div className="container">
        <h2 className="section__title reveal">
          {es_en ? "Recruiter FAQ" : "Preguntas de Reclutador"}
        </h2>
        <p className="section__subtitle reveal">
          {es_en
            ? "Quick answers about profile, stack, and availability"
            : "Respuestas rápidas sobre perfil, stack y disponibilidad"}
        </p>

        <div className="faq__container reveal">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`faq__item ${
                expandedId === faq.id ? "faq__item--active" : ""
              }`}
            >
              <button
                type="button"
                className="faq__header"
                aria-expanded={expandedId === faq.id}
                onClick={() => toggleExpanded(faq.id)}
              >
                <h3 className="faq__question">{faq.question}</h3>
                <span className="faq__icon">
                  <i
                    className={`uil ${
                      expandedId === faq.id ? "uil-angle-up" : "uil-angle-down"
                    }`}
                  ></i>
                </span>
              </button>

              <div
                className={`faq__content ${
                  expandedId === faq.id ? "faq__content--active" : ""
                }`}
              >
                <p className="faq__answer">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
